import {
  SearchListFilterInput,
  SearchResultDto,
  SortingDirection,
} from 'src/graphql/generated/graphql';
import { useTable } from 'src/hooks/use-table';
import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { TableWrapper } from 'src/components/common/wrapper/table/wrapper';
import { FilterWrapper } from 'src/components/common/wrapper/filter/wrapper';
import { SearchListFilter } from './filter';
import React, { useEffect } from 'react';
import { useSearch } from 'src/hooks/query/search/use-search';
import { SearchTable } from './table';
import { SetURLSearchParams, useSearchParams } from 'react-router-dom';

const PAGINATION_LIMIT = 10;

interface SearchListProps {
  search?: string;
  setSearchParams?: SetURLSearchParams;
}

export const SearchList = ({ search, setSearchParams }: SearchListProps) => {
  const {
    page,
    setPage,
    filter,
    onFilterChange,
    defaultFilter,
    sorting,
    onSortChange,
  } = useTable<SearchListFilterInput, Record<string, SortingDirection>>({
    defaultFilter: {
      search: search,
    },
  });
  useEffect(() => {
    if (search && filter.search !== search) {
      onFilterChange({
        ...filter,
        search: search,
      });
    }
  }, [search]);

  const { loading, data } = useSearch({
    filter,
    sorting,
    pagination: {
      page,
      limit: PAGINATION_LIMIT,
    },
    skip: !search,
  });

  return (
    <>
      <FilterWrapper>
        <SearchListFilter
          onSubmit={(
            value: Record<string, string | number | Array<string | number>>,
          ) => {
            onFilterChange(value);
            setSearchParams?.({ search: value.search as string });
          }}
          defaultFilter={defaultFilter}
        />
      </FilterWrapper>
      <ContentWrapper>
        <TableWrapper>
          <SearchTable
            data={(data?.search.records as Partial<SearchResultDto>[]) || []}
            className="mt-4"
            loading={loading}
            options={{
              page,
              count: data?.search.pagination.totalCount,
              rowsPerPage: PAGINATION_LIMIT,
              onChangePage: setPage,
              onColumnSortChange: onSortChange,
              enableNestedDataAccess: '.',
            }}
          />
        </TableWrapper>
      </ContentWrapper>
    </>
  );
};
